import React, { useMemo, Fragment, useState, useEffect } from 'react';
import { MaterialReactTable } from 'material-react-table';
import ListItemIcon from '@mui/material/ListItemIcon';
import MenuItem from '@mui/material/MenuItem';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { useGetSignedInUserDetails } from '../../../hooksAndFunctions/customHooks/useGetSignedInUserDetails'
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import MpgConfirmDialog from "../../../common/dialog/MpgConfirmDialog";

const BioTable = ({ tableData, setTableData, setRemovedBioListDuringEditFunc, removedBioList, setOpenEditBioDialog, setBioDetailObjToBeEdited ,cmsData }) => {

    const { userName } = useGetSignedInUserDetails();
     // #region Cms content handling
     const fetchBioDetailsComponentLabel = (key) => {
        if (cmsData?.pageContent && cmsData?.pageContent["BioDetailListComponent"]) {
            const adminBioDetailsLabel = cmsData.pageContent["BioDetailListComponent"];
            return returnLabel(adminBioDetailsLabel?.Labels, key)
        }
        return '';
    }

    const fetchCommonCMSLabel = (key) => {
        if (cmsData?.pageContent && cmsData?.pageContent["CommonComponent"]) {
            const commonLabels = cmsData.pageContent["CommonComponent"];
            return returnLabel(commonLabels?.Labels, key)
        }
        return '';
    }

    const returnLabel = (labelArray=[], key) => {
            return labelArray.find((x) => x.Key === key)?.Phrase || '';
    }
    // #endregion

    const columns = useMemo(
        () => [
            {
                accessorKey: 'TemplateTitle',
                header: fetchBioDetailsComponentLabel('BioDetailList.BioTemplateTitle'),
                filterFn: 'contains',
                muiTableHeadCellFilterTextFieldProps: { placeholder: fetchBioDetailsComponentLabel("BioDetailList.PlaceholderBioTemplateTitle") }
            },
            {
                accessorKey: 'LanguageDescription',
                header: fetchBioDetailsComponentLabel('BioDetailList.Language'),
                filterFn: 'contains',
                muiTableHeadCellFilterTextFieldProps: { placeholder: fetchBioDetailsComponentLabel("BioDetailList.PlaceholderLanguage") }
            },
            {
                accessorKey: 'Content', //normal accessorKey
                header: fetchBioDetailsComponentLabel('BioDetailList.Content'),
                filterFn: 'contains',
                muiTableHeadCellFilterTextFieldProps: { placeholder: fetchBioDetailsComponentLabel("BioDetailList.PlaceholderContent") }
            }
        ],
        [cmsData],
    );

    const removeBioDetailTableEntry = ({ idToBeRemoved }) => {

        let removedBiosWhichRCommingFromDB = []

        const newList = !!tableData && tableData.filter((item) => {
            if (item?.Id !== idToBeRemoved) {
                return item
            }

            /**only for edit account team member */
            if (!!setRemovedBioListDuringEditFunc) {
                if (item?.Id === idToBeRemoved && item?.flag !== "notFromDB") {
                    removedBiosWhichRCommingFromDB.push({
                        ...item,
                        IsActive: false,
                        UpdatedBy: userName
                    })
                }
            }

        })
        setTableData(newList)

        const allRemovedBiosList = [...removedBioList, ...removedBiosWhichRCommingFromDB]

        /**only for edit account team member */
        if (!!setRemovedBioListDuringEditFunc) {
            setRemovedBioListDuringEditFunc(allRemovedBiosList)
        }
    }

    /**  */
    const [openMpgConfirmDialog, setOpenMpgConfirmDialog] = useState(false)
    const [idAndBioTitleTobeDeleted, setIdAndBioTitleTobeDeleted] = useState({
        id: "",
        bioTemplateTitle: ""
    })
    /**hashtable for biotemplate */

    /**hash table is required to know number of entries with same bioTemplateTitle. we need to raise delete alert only when that count is 1. Indication last entry left. 
     * USAGE: we need to row alert on delet only when last biotitle is available in table with same bioTemplatetitles
     */
    let hashTableForBioTemplate = {}

    !!tableData && tableData.forEach((item) => {
        /**to ignore casing for bioTemplateTitle */
        const lowerCaseItemTitle = item.TemplateTitle.toLowerCase()
        if (!!hashTableForBioTemplate[lowerCaseItemTitle]) {

            hashTableForBioTemplate[lowerCaseItemTitle] = hashTableForBioTemplate[lowerCaseItemTitle] + 1
        } else {
            hashTableForBioTemplate[lowerCaseItemTitle] = 1
        }
    })

    // console.log("hashTableForBioTemplate", hashTableForBioTemplate)

    return (
        <Fragment>
            <MaterialReactTable
                columns={columns}
                data={tableData}
                enableTopToolbar={!!tableData && tableData.length ? true : false}
                enableBottomToolbar={!!tableData && tableData.length ? true : false}
                displayColumnDefOptions={{
                    'mrt-row-actions': {
                        header: fetchBioDetailsComponentLabel('BioDetailList.Actions'),
                    },
                }}
                muiTablePaginationProps={{
                    labelRowsPerPage: fetchCommonCMSLabel('Common.Rowsperpage') //Rows per page
                }}
                layoutMode="grid"
                enableGlobalFilter={false}
                enableDensityToggle={false}

                initialState={{
                    density: 'compact',
                    showColumnFilters: true
                }}

                enableRowActions

                renderRowActions={({ row, table }) => {
                    return (
                        <Box sx={{ display: 'flex', flexWrap: 'nowrap', gap: '8px' }}>
                            <IconButton
                                onClick={() => {
                                    const bioId = row.original.Id

                                    const bioToBeEdited = tableData.find((item) => item.Id === bioId)

                                    if (!!bioToBeEdited) {
                                        setBioDetailObjToBeEdited(bioToBeEdited)
                                    }

                                    setOpenEditBioDialog(true)
                                }}
                            >
                                <EditIcon />
                            </IconButton>
                            <IconButton
                                onClick={() => {
                                    const id = row.original.Id
                                    const templateTitle = row.original.TemplateTitle

                                    const templateTitleInLowerCase = templateTitle.toLowerCase()

                                    if (hashTableForBioTemplate[templateTitleInLowerCase] === 1) {
                                        /**raise alert when last biotemplate is avilable */
                                        setIdAndBioTitleTobeDeleted({
                                            id,
                                            bioTemplateTitle: templateTitle
                                        })
                                        setOpenMpgConfirmDialog(true)
                                    } else {
                                        removeBioDetailTableEntry({ idToBeRemoved: id })
                                    }

                                }}
                            >
                                <DeleteIcon />
                            </IconButton>
                        </Box>
                    )
                }}


                renderRowActionMenuItems={({ closeMenu, row }) => {
                    return (
                        [
                            <MenuItem
                                key={0}

                                sx={{ m: 0 }}
                            >
                                <ListItemIcon>
                                    <EditIcon />
                                </ListItemIcon>
                                Edit
                            </MenuItem>,
                            <MenuItem
                                key={1}

                                sx={{ m: 0 }}
                            >
                                <ListItemIcon>
                                    <DeleteIcon />
                                </ListItemIcon>
                                Delete
                            </MenuItem>,
                        ]
                    )
                }}
            />

            {/** confirm dialog on delete action */}
            <MpgConfirmDialog
                content={fetchBioDetailsComponentLabel('BioDetailList.PopUpBioDeleteConfirmationMsg')?.replace('#BIO_TEMPLATE_TITLE#', `"${idAndBioTitleTobeDeleted?.bioTemplateTitle}"`)}     
                open={openMpgConfirmDialog}
                setOpen={setOpenMpgConfirmDialog}
                extraLogicHandlerOnAgree={() => {
                    removeBioDetailTableEntry({ idToBeRemoved: idAndBioTitleTobeDeleted?.id })

                    setIdAndBioTitleTobeDeleted({
                        id: "",
                        bioTemplateTitle: ""
                    })
                }}
            />
        </Fragment>
    )
}
export default BioTable